<style lang="css" scoped>
/* Container principal */
.account-container {
  max-width: 800px;
  margin: 0 auto;
  padding: 2rem;
  min-height: 100vh;
}

/* Cabeçalho da página */
.page-header {
  margin-bottom: 2rem;
  text-align: center;
}

.page-title {
  color: var(--text-primary, #1e293b);
  font-size: 2rem;
  font-weight: 700;
  margin-bottom: 0.5rem;
  align-items: center;
  justify-content: center;
  gap: 0.75rem;
}

.page-title i {
  color: var(--accent-color, #3b82f6);
  font-size: 1.75rem;
}

.page-subtitle {
  color: var(--text-secondary, #64748b);
  font-size: 1.1rem;
  margin: 0;
}

/* Card do formulário */
.form-card {
  background: var(--card-background, #ffffff);
  border-radius: 16px;
  border: 1px solid var(--border-color, #e2e8f0);
  box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1);
  overflow: hidden;
  transition: all 0.3s ease;
}

.form-card:hover {
  box-shadow: 0 8px 25px -5px rgba(0, 0, 0, 0.1);
  transform: translateY(-2px);
}

.card-header {
  background: linear-gradient(135deg, var(--secondary-color, #f8fafc), var(--card-background, #ffffff));
  padding: 1.5rem 2rem;
  border-bottom: 1px solid var(--border-color, #e2e8f0);
}

.card-title {
  color: var(--text-primary, #1e293b);
  font-size: 1.25rem;
  font-weight: 600;
  margin: 0;
  display: flex;
  align-items: center;
  gap: 0.75rem;
}

.card-title i {
  color: var(--accent-color, #3b82f6);
  font-size: 1.1rem;
}

.card-body {
  padding: 2rem;
}

/* Grid do formulário */
.form-grid {
  display: grid;
  gap: 1.5rem;
  margin-bottom: 2rem;
}

/* Campos de input */
.input-field {
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
}

.field-label {
  color: var(--text-secondary, #64748b);
  font-weight: 500;
  font-size: 0.9rem;
  display: flex;
  align-items: center;
  gap: 0.5rem;
}

.field-label i {
  color: var(--accent-color, #3b82f6);
  font-size: 0.85rem;
}

.field-input {
  padding: 0.875rem 1rem;
  border: 2px solid var(--border-color, #e2e8f0);
  border-radius: 8px;
  font-size: 1rem;
  transition: all 0.3s ease;
  background: var(--input-background, #ffffff);
  color: var(--text-primary, #1e293b);
}

.field-input:focus {
  outline: none;
  border-color: var(--accent-color, #3b82f6);
  box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.1);
  background: var(--bg-primary, #ffffff);
}

.field-input::placeholder {
  color: var(--text-muted, #94a3b8);
  font-size: 0.95rem;
}

/* Footer do formulário */
.form-footer {
  display: flex;
  justify-content: center;
  gap: 1rem;
}

.btn {
  padding: 0.875rem 2rem;
  border-radius: 8px;
  font-weight: 500;
  font-size: 1rem;
  transition: all 0.3s ease;
  border: none;
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  gap: 0.5rem;
  text-decoration: none;
}

.btn-primary {
  background: linear-gradient(135deg, var(--primary-color, #3b82f6), var(--primary-hover, #2563eb));
  color: #ffffff;
  box-shadow: 0 2px 4px rgba(59, 130, 246, 0.2);
}

.btn-primary:hover {
  background: linear-gradient(135deg, var(--primary-hover, #2563eb), var(--primary-color, #3b82f6));
  box-shadow: 0 4px 12px rgba(59, 130, 246, 0.3);
  transform: translateY(-1px);
}

.btn-primary:active {
  transform: translateY(0);
  box-shadow: 0 2px 4px rgba(59, 130, 246, 0.2);
}

/* Responsividade */
@media (max-width: 768px) {
  .account-container {
    padding: 1rem;
  }

  .page-title {
    font-size: 1.5rem;
    flex-direction: column;
    gap: 0.5rem;
  }

  .page-title i {
    font-size: 1.5rem;
  }

  .card-header,
  .card-body {
    padding: 1.5rem;
  }

  .form-grid {
    gap: 1rem;
  }

  .btn {
    width: 100%;
    padding: 1rem;
  }
}

/* Suporte ao tema escuro */
[data-theme="dark"] .form-card {
  background: var(--card-background, rgba(37, 37, 41, 0.9));
  border-color: var(--border-color, #52525b);
}

[data-theme="dark"] .card-header {
  background: linear-gradient(135deg, var(--secondary-color, rgba(31, 31, 35, 0.8)), var(--card-background, rgba(37, 37, 41, 0.9)));
  border-bottom-color: var(--border-color, #52525b);
}

[data-theme="dark"] .field-input {
  background: var(--input-background, rgba(26, 26, 29, 0.8));
  border-color: var(--border-color, #52525b);
  color: var(--text-primary, #f4f4f5);
}

[data-theme="dark"] .field-input:focus {
  background: var(--bg-secondary, rgba(31, 31, 35, 0.8));
}
</style>
<template>
  <div class="account-container">
    <!-- Cabeçalho da página -->
    <div class="page-header">
      <h1 class="page-title">
        <i class="fa-solid fa-user-lock"></i>
        Minha Conta
      </h1>
      <p class="page-subtitle">Altere sua senha de acesso ao sistema</p>
    </div>

    <!-- Card do formulário -->
    <div class="form-card">
      <div class="card-header">
        <h3 class="card-title">
          <i class="fa-solid fa-key"></i>
          Alteração de Senha
        </h3>
      </div>
      
      <div class="card-body">
        <div class="form-grid">
          <div class="input-field">
            <label class="field-label">
              <i class="fa-solid fa-lock"></i>
              Senha Atual
            </label>
            <input 
              class="field-input" 
              type="password" 
              v-model="account.currentPassword" 
              autocomplete="current-password"
              placeholder="Digite sua senha atual"
            />
          </div>

          <div class="input-field">
            <label class="field-label">
              <i class="fa-solid fa-lock-open"></i>
              Nova Senha
            </label>
            <input 
              class="field-input" 
              type="password" 
              v-model="account.newPassword" 
              autocomplete="new-password"
              placeholder="Digite sua nova senha"
            />
          </div>
        </div>

        <div class="form-footer">
          <button type="button" class="btn btn-primary" @click="save()">
            <i class="fa-solid fa-save"></i>
            Salvar Alterações
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import mainService from "@/services/mainService";
import { toast } from "@/composables/useToast";
import { handleErrorMessage } from "@/services/config";
export default {
  data: () => ({
    account: {
      userId: "e4d7cd93-4976-42f6-96f4-923051775cf1",
      name: "Admin",
      currentPassword: null,
      newPassword: null
    },
  }),
  mounted() { },
  methods: {
    validateAccount() {
      if (
        this.account.currentPassword == null || this.account.currentPassword == "" ||
        this.account.newPassword == null || this.account.newPassword == ""
      ) {
        toast.error("Por favor, preencha todos os campos!");
        return false;
      }
      return true;
    },
    save() {
      if (this.validateAccount()) {
        mainService
          .resetPassword(this.account)
          .then(() => {
            toast.success("Senha alterada com sucesso!");
            localStorage.setItem("isAuthenticated", "false");
            this.account = {}
          })
          .catch((error) => {
            toast.error("Senha atual inválida");
          })
          .finally(() => { });
      }
    },
  },
};
</script>
